export default __webpack_public_path__ + "static/media/java.97f9b636.svg";